module.exports = __webpack_public_path__ + "static/media/Aesir2.ee243069.png";